export enum AppliedStatus {
  Eligible = 'eligible',
  Applied = 'applied',
  Invited = 'invited',
  Confirmed = 'confirmed',
  NotSelected = 'not_selected',
}
